/**
 * 杂项 hooks（TanStack Query）：通知 / 审计日志。
 * 注意：PATCH /notifications/:id/read 在后端语义为 markSent（置 status=SENT/sentAt），
 * 并不存在"已读"字段——前端 UI 按"标记已处理"呈现。
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listAudit, listNotifications, markNotificationRead } from '../lib/api';

export function useNotifications(query?: { page?: number; pageSize?: number }) {
  return useQuery({
    queryKey: ['notifications', query ?? {}],
    queryFn: () => listNotifications(query),
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markNotificationRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useAudit(query?: { page?: number; pageSize?: number }) {
  return useQuery({
    queryKey: ['audit', query ?? {}],
    queryFn: () => listAudit(query),
  });
}
